import Vue from "vue"
import { Capacitor } from '@capacitor/core'

const state = {
	progress: false,
	is_mobile: false,
	base_url: "",
	dialTimeout: 800,
	snackbar: {
		timeout: 6000,
		value: false,
		color: "",
		text: ""
  	},
	  modelEdited: false,

	  adminUrl: process.env.VUE_APP_BASE_URL,

	  // Larghezza da riservare alla sidebar dei filtri finche' il drawer non e'
	  // montato: nasce solo dopo la info API, e senza questo il contenuto
	  // partirebbe a tutta pagina per poi restringersi. Appena il drawer esiste
	  // comanda lui, tramite $vuetify.application.right.
	  filterDrawerReservedWidth: 0,

	  maintenanceMode: {
		active: false,
		message: ''
	  },

	  updateAvailable: false
}

const getters = {
	progress: state => state.progress,

	isMobile: state => state.is_mobile,

	baseUrl: state => state.base_url,

	dialTimeout: state => state.dialTimeout,

	snackbar: state => state.snackbar,

	modelEdited: state => state.modelEdited,

	adminUrl: state => state.adminUrl,

	filterDrawerReservedWidth: state => state.filterDrawerReservedWidth,

	maintenanceMode: state => state.maintenanceMode,

	isInMaintenance: state => state.maintenanceMode.active,

	updateAvailable: state => state.updateAvailable
}

const mutations = {
	startProgress: state => {
		state.progress = true
	},
	endProgress: state => {
		state.progress = false
	},
	setMobile: (state, is_mobile) => {
		state.is_mobile = is_mobile
	},
	setBaseUrl: (state, base_url) => {
		state.base_url = base_url
	},
	setSnackbar: (state, snackbar) => {
		state.snackbar = {...snackbar}
	},
	setFilterDrawerReservedWidth: (state, width) => {
		state.filterDrawerReservedWidth = width
	},
	setSnackbarError: (state) => {
		state.snackbar = {
			timeout: 6000,
			text: 'Ops.. Qualcosa è andato storto',
			value: true,
			color: 'error'
		}
	},
	setModelEdited: (state, modelEdited) => {
		state.modelEdited = modelEdited
	},
	setMaintenanceMode: (state, maintenance) => {
		state.maintenanceMode = { ...maintenance }
	},
	clearMaintenanceMode: (state) => {
		state.maintenanceMode = { active: false, message: '' }
	},
	setUpdateAvailable: (state, available) => {
		state.updateAvailable = available
	}
}

const actions = {
	CHECK_MOBILE: ({ commit }) => {
		// Usa Capacitor per verificare se siamo su piattaforma nativa
		const isNative = Capacitor.isNativePlatform()
		commit('setMobile', isNative)
	},
	SET_FQDN: ({ commit }) => {
		if (process.env.NODE_ENV === 'development') {
			if (localStorage.getItem('fqdn') !== null) {
				commit('setBaseUrl',
				localStorage.getItem('fqdn').includes('.') ? 'http://' + localStorage.getItem('fqdn') : 'http://' + localStorage.getItem('fqdn') + process.env.VUE_APP_LOCAL_URL)
			}
		} else {
			if (localStorage.getItem('fqdn') !== null) {
				 if (process.env.VUE_APP_STAGING == 'true' || window.location.hostname.includes('staging')) {
					commit('setBaseUrl', 'https://' + localStorage.getItem('fqdn') + '.backyello2.stiip.it')
				} else {
					commit('setBaseUrl', 'https://' + localStorage.getItem('fqdn') + '.backyello.stiip.it')
				}
			}
		}
		Vue.axios.defaults.baseURL = state.base_url + '/api'
	}
}

export default {
  state,
  getters,
  mutations,
  actions
}
